<template>
  <el-dialog
      lock-scroll
      :modal-append-to-body="false"
      :append-to-body="true"
      :title="$lang('面单预览')"
      custom-class="j-dialog"
      :close-on-click-modal="false"
      top="45px"
      :visible.sync="orderPdfViewVisible"
      @close="close"
      width="80%"
  >
    <div style="height: 590px;">
      <el-row>
        <el-col :span="12"  style="font-size: 20px;color: red">
            {{$lang('双击单号可以切换预览图片')}}
        </el-col>
        <el-col :span="10" :offset="2">
            <el-button  type="submit"  @click="prePage" > {{$lang('上一页')}} </el-button>
            <el-button  type="submit"  @click="nextPage" > {{$lang('下一页')}} </el-button>
            <template v-if="pageNum > 0">
              {{pageNum}} /{{pageTotalNum}}
            </template>
            <el-button  type="submit"  @click="clock" > {{$lang('顺时针')}} </el-button>
            <el-button  type="submit"  @click="counterClock" > {{$lang('逆时针')}} </el-button>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12" style="padding-top: 10px">
          <el-table
              @row-dblclick="loadPdfData"
              :data="tableData"
              stripe
              border
              cell-style="cursor:pointer;"
              style="width: 98%">
            <el-table-column
                type="index"
                :label="$lang('序号')"
                width="150">
            </el-table-column>
            <el-table-column
                prop="waybillId"
                :label="$lang('运单号')"
                >
            </el-table-column>
            <el-table-column
                prop="printsNumber"
                :label="$lang('打印次数')"
                >
            </el-table-column>
            <el-table-column
                fixed="right"
                :label="$lang('操作')"
                width="100">
              <template slot-scope="scope">
                <el-button type="text" size="small" @click="downloadPdf(scope.row)">{{$lang('下载')}}</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
        <el-col :span="12"  style="padding-top: 10px">
          <pdf ref="pdf"
               style="border: 1px solid #000000"
               :src="pdfData"
               :page="pageNum"
               :rotate="pageRotate"
               @page-loaded="pageLoaded($event)"
               @num-pages="pageTotalNum=$event">
          </pdf>
        </el-col>
      </el-row>
    </div>
  </el-dialog>

</template>

<script>
import Axios from 'axios'
import Store from '@store'
import Pdf from 'vue-pdf'
// 中文PDF加载空白引入依赖
import CMapReaderFactory from 'vue-pdf/src/CMapReaderFactory.js'

export default {
  name: 'OrderPdfView',
  components: {
    Pdf,
  },
  props: {
    orderPdfViewVisible: Boolean,
    orderPdfViewData: Object,
  },
  watch: {
    'orderPdfViewData' (val) {
      for (let i = 0; i < val.data.length; i++) {
        this.tableData.push({ id: val.data[i].id, waybillId: val.data[i].waybillId, printsNumber: val.data[i].printsNumber })
      }
      this.loadPdfData(val.data[0])
    },
  },
  data() {
    return {
      downloadPdfUrl: '',
      tableData: [],
      pdfData: '',
      pageNum: undefined,
      pageTotalNum: 0,
      pageRotate: 0,
    }
  },
  methods: {
    async downloadPdf(row) {
      await this.loadPdfData(row)
      const a = document.createElement('a')
      a.style.display = 'none'
      a.download = (row.waybillId || row.id.toString()) + '.pdf'
      a.href = this.downloadPdfUrl
      a.click()
    },
    // 页面加载回调函数，其中e为当前页数
    pageLoaded(e) {
      this.pageNum = e
    },
    // 上一页函数，
    prePage() {
      if (this.pageTotalNum === 0 || !this.pageTotalNum) {
        return
      }
      var page = this.pageNum
      page = page > 1 ? page - 1 : this.pageTotalNum
      this.pageNum = page
    },
    // 下一页函数
    nextPage() {
      if (this.pageTotalNum === 0 || !this.pageTotalNum) {
        return
      }
      var page = this.pageNum
      page = page < this.pageTotalNum ? page + 1 : 1
      this.pageNum = page
    },
    // 页面顺时针翻转90度。
    clock() {
      if (this.pageTotalNum === 0 || !this.pageTotalNum) {
        return
      }
      this.pageRotate += 90
    },
    // 页面逆时针翻转90度。
    counterClock() {
      if (this.pageTotalNum === 0 || !this.pageTotalNum) {
        return
      }
      this.pageRotate -= 90
    },
    loadPdfData: async function (row) {
      const { token = '' } = Store.getters
      await Axios({
        method: 'GET',
        headers: { 'authtoken': token },
        url: (process.env.VUE_APP_API_URL || 'https://vipgw.jtcargo.my') + '/vip/order/orderPdfView',
        params: { idstr: row.id.toString(), command: this.orderPdfViewData.command, isVip: true },
        responseType: 'blob', // 更改responseType类型为 blob
      }).then(res => {
        if (res.data.type === 'application/pdf') {
          this.pageNum = 1
          const url = URL.createObjectURL(res.data)
          this.pdfData = Pdf.createLoadingTask({ url: url, CMapReaderFactory })
          this.pdfData.promise.then(pdf => {
            this.pageTotalNum = pdf.numPages
          })
          this.downloadPdfUrl = url
        } else if (res.data.type === 'application/json') {
          this.pageNum = 0
          this.pageTotalNum = 0
          this.pdfData = ''
          const reader = new FileReader()
          reader.readAsText(res.data)
          reader.onload = (event) => {
            const msg = JSON.parse(reader.result).msg || '' // 错误信息
            this.$message.error(this.$lang(msg))
          }
          return
        }
      }).catch(err => {
        console.log(err)
      })
    },
    close() {
      this.pageNum = 0
      this.pageTotalNum = 0
      this.tableData = []
      this.pdfData = ''
      this.$emit('close')
    },
  },
  mounted() {
    // this.loadPdfData()
  },
}
</script>

<style scoped>

</style>
